import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Loading from '../../loadings';
import { List } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';

class Status extends React.Component {

  state = {
    maxWidth: 'xs',
    fullWidth: true,
    statusDialog: false
  }

  changeStatus(status) {
    let context = this;
    let id = this.props.id;
    $.ajax({
      type: 'POST',
      data: { 'id': id, 'status': status },
      url: Server() + 'machinesales/statuschange.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          context.setState({ statusDialog: false })
          context.props.getorder(1);
        }
        else {
          alert('PDF not upload');
        }
      },
      error: function(err)
      {
        context.setState({
          error: "Try again",
        });
      }
    });
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <div style={{color: '#5D98E8', cursor: 'pointer'}} onClick={ () => { this.setState({ statusDialog: true }) } } >
          {this.props.status}
        </div>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.statusDialog}
            onClose={ () => { this.setState({ statusDialog: false }) }} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Change Status</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <List divided relaxed>
                  <List.Item>
                    <List.Content>
                      <List.Header as='a' onClick={this.changeStatus.bind(this, 'Open')}>
                        Open
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header as='a' onClick={this.changeStatus.bind(this, 'Processing')}>
                        Processing
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header as='a' onClick={this.changeStatus.bind(this, 'Success')}>
                        Success
                      </List.Header>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header as='a' onClick={this.changeStatus.bind(this, 'Fail')}>
                        Fail
                      </List.Header>
                    </List.Content>
                  </List.Item>
                </List>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => { this.setState({ statusDialog: false }) } }>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Status;
